import { THour } from '../reducer/initialState';

const START_FROM = 9;
const END_AT = 21;

/**
 * Getting a list of all hours for service engineer calling
 * at ideal world this action must be implemented on back-end side
 */
const hourListForDay = ((): Record<string, THour> => {
    const result = {} as Record<string, THour>;

    for (let idx = START_FROM; idx < END_AT; idx++) {
        const from = String(idx);
        const to = String(idx + 1);
        result[from] = { from, to, active: false, cost: undefined };
    }

    return result;
})();

export default hourListForDay;
